module.exports = __webpack_public_path__ + "img/calc-3.3eb9c397.png";